import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
interface InitialState {
    downloading: boolean;   
    rawdatadownloading: boolean;   
}
const initialState: InitialState = {
    downloading: false,
    rawdatadownloading: false,
};
const dashboardDownloadSlice = createSlice({
    name: "dashboardDownload",
    initialState,
    reducers: {
        setDownloading: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            downloading: action.payload,
        }),
        setRawDataDownloading: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            rawdatadownloading: action.payload,
        }),
    }    
})
export const { setDownloading,setRawDataDownloading } = dashboardDownloadSlice.actions;
export default dashboardDownloadSlice.reducer;
